import { useEffect, useState } from 'react';
import { RenderConfigScreenCtx } from 'datocms-plugin-sdk';
import { Canvas, SwitchField } from 'datocms-react-ui';
import { readEdgeConfigSingleItem, requireUserToken } from '../utils/edgeConfig';

type Props = {
  ctx: RenderConfigScreenCtx;
};

export default function ConfigScreen({ ctx }: Props) {
  const [ isActive, setIsActive ] = useState(ctx.plugin.attributes.parameters.testModeSwitcherIsActive as boolean);

  useEffect(() => {
    (async() => {
      try {
        const token = requireUserToken(ctx);
        const results = await Promise.all([
          readEdgeConfigSingleItem({ key: 'cpb_test_mode', token }),
          readEdgeConfigSingleItem({ key: 'crt_test_mode', token }),
          readEdgeConfigSingleItem({ key: 'ctv_test_mode', token }),
          readEdgeConfigSingleItem({ key: 'ftc_test_mode', token }),
          readEdgeConfigSingleItem({ key: 'nlc_test_mode', token })
        ]);

        const numOfTestMode = results.filter(value => value === true).length;

        await ctx.updatePluginParameters({
          testModeSwitcherIsActive: isActive,
          numOfTestMode: numOfTestMode
        })
      } catch(error) {
        // Persist the activation toggle even when the reads fail, keeping the
        // previously stored count instead of clobbering it with 0
        await ctx.updatePluginParameters({
          ...ctx.plugin.attributes.parameters,
          testModeSwitcherIsActive: isActive,
        });
        ctx.alert(String(error));
      }
    })()
  // ctx intentionally omitted — it changes reference on every render and would cause an infinite loop
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isActive]);

  return (
    <Canvas ctx={ctx}>
      <p style={{ fontSize: 'var(--font-size-l)' }}>By activating this plugin, you can access the Test Mode page to update Edge Config for each website.</p>
       <SwitchField
        name="activate"
        id="activate"
        label="Activate this plugin?"
        value={isActive}
        onChange={(newValue: boolean) => setIsActive(newValue)}
      />
    </Canvas>
  );
}
